import { render, staticRenderFns } from "./DrawCoupon.vue?vue&type=template&id=bf5bf1a0&scoped=true&"
import script from "./DrawCoupon.vue?vue&type=script&lang=js&"
export * from "./DrawCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DrawCoupon.vue?vue&type=style&index=0&id=bf5bf1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5bf1a0",
  null
  
)

export default component.exports